import styled from 'styled-components';
import {
    MobileWidgetCardsHeaderStyled,
    MobileWidgetCardsSeeAllStyled
} from "../../../../../../mobileAppCore/components/MobileWidgets/MobileWidgetCards/styled/MobileWidgetCardsStyled";

export const LiteTradePortfolioLastViewedStyled = styled.div`
    margin-bottom: 24px;

    .card-title {
        font-size: 16px;
        font-weight: 600;
        color: var(--color-label-secondary);
    }

    ${MobileWidgetCardsSeeAllStyled} {
        font-size: 16px;
        color: var(--color-label-secondary);

        .arrow-icon {
            fill: var(--color-label-secondary);
        }
    }

    ${MobileWidgetCardsHeaderStyled} {
        margin-bottom: 0;
    }
`;
